import React, { useEffect, useState } from "react";
import DataTable from "../../components/Table/DataTable";
import { formatDateToNextDay } from "../../utils/dateFormat";
import { getStatusBadge } from "../../shared/constants";
const headers = [
  { field: "transportDate", headerName: "Transport Date" },
  { field: "ticketId", headerName: "Ticket Id" },
  { field: "orderId", headerName: "Order Id" },
  { field: "name", headerName: "Full Name" },
  { field: "firstName", headerName: "First Name" },
  { field: "lastName", headerName: "Last Name" },
  { field: "orderStatus", headerName: "Order Status" },
  { field: "workflow", headerName: "Workflow" },
  { field: "externalId", headerName: "External Id" },
  { field: "transProvider", headerName: "Transport Provider" },
  { field: "actionComments", headerName: "Action Comments" },
  { field: "actionBy", headerName: "Action By" },
  { field: "actionTimestamp", headerName: "Action Timestamp" },
  { field: "estTransEnd", headerName: "Estimated Transport End" },
  { field: "workflowText", headerName: "Workflow Text", renderCell: (params) => getStatusBadge(params?.workflowText) },
  { field: "siteCode", headerName: "Site Code" },
  { field: "changedDate", headerName: "Changed Date" },
  { field: "apptTime", headerName: "Appointment Time" },
  { field: "personId", headerName: "Person Id" },
  { field: "personCreated", headerName: "Person Created" },
  { field: "driverId", headerName: "Driver Id" },
  { field: "statusType", headerName: "Status Type" },
  { field: "estMiles", headerName: "Estimated Miles" },
  { field: "puTime", headerName: "Pickup Time" },
  { field: "doTime", headerName: "Dropoff Time" },
  { field: "healthcarePlan", headerName: "Healthcare Plan" },
  { field: "benefitPlan", headerName: "Benefit Plan" },
  { field: "organization", headerName: "Organization" },
  { field: "programCode", headerName: "Program Code" },
  { field: "pickupNotes", headerName: "Pickup Notes" },
  { field: "returnNotes", headerName: "Return Notes" },
  { field: "puAddress", headerName: "Pickup Address" },
  { field: "puCity", headerName: "Pickup City" },
  { field: "puState", headerName: "Pickup State" },
  { field: "puZip", headerName: "Pickup Zip" },
  { field: "doAddress", headerName: "Dropoff Address" },
  { field: "doCity", headerName: "Dropoff City" },
  { field: "doState", headerName: "Dropoff State" },
  { field: "doZip", headerName: "Dropoff Zip" },
  { field: "authorizationCode", headerName: "Authorization Code" },
  { field: "ovrDriverName", headerName: "Override Driver Name" },
  { field: "ovrDriverId", headerName: "Override Driver Id" },
  { field: "ovrVin", headerName: "Override VIN" },
  { field: "ovrTripMiles", headerName: "Override Trip Miles" },
  { field: "ovrPuOdometer", headerName: "Override Pickup Odometer" },
  { field: "ovrDoOdometer", headerName: "Override Dropoff Odometer" },
  { field: "ovrTos", headerName: "Override TOS" },
  { field: "ovrTad", headerName: "Override TAD" },
  { field: "ovrPuTls", headerName: "Override Pickup TLS" },
  { field: "ovrDoTls", headerName: "Override Dropoff TLS" },
  { field: "ovrBilledDate", headerName: "Override Billed Date" },
  { field: "aorr", headerName: "AORR" },
  { field: "fullCount", headerName: "Full Count" }
];
const List = ({ rows, rowsPerPage, totalCount, page, setRowsPerPage, fetchTrips, setPage }) => {

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  useEffect(() => {
    // const delay = searchText ? 500 : 0;

    const timer = setTimeout(() => {
      fetchTrips();
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsPerPage, page]);
  const dateFields = ['transportDate'];

  const formatDatesInRows = () => {
    return rows?.map((row) => {
      dateFields.forEach(field => {
        if (row[field]) {
          row[field] = formatDateToNextDay(row[field]); // Apply the date formatting function
        }


      });
      return row;
    });
  };
  return (
    <>
      <DataTable
        columns={headers}
        rows={formatDatesInRows()}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalCount={totalCount}
        page={page}
      />
    </>
  )
}
export default List